export const routesList = [
  {
    path: '/admin',
    name: 'Home',
    // meta: { requireAuth: true },
    // true
    component: () => import('../views/Dashboard.vue'),
  },
  {
    path: '/admin/login',
    // name: 'Login',
    // meta: { requireAuth: false },
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/admin/detail',
    // name: 'Info',
    meta: { requireAuth: true },
    component: () => import('../views/Detail.vue'),
  },
  {
    path: '/admin/testDetail',
    component: () => import('../views/surveyDetail2.vue'),
  },
];
